import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    refinementReason: null,
    hasChanged: false,
    fetching: false,
    error: null,
}

export default handleActions({
    [type.GET_REFINEMENT_REASON_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            refinementReason: null,
        }
    },
    [type.GET_REFINEMENT_REASON_SUCCESS]: (state, action) => {
        const { refinementReason } = action.payload
        return {
            ...state,
            refinementReason,
            fetching: false,
        }
    },
    [type.GET_REFINEMENT_REASON_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_REFINEMENT_REASON]: (state, action) => {
        const { refinementReason } = action.payload
        return {
            ...state,
            refinementReason,
            hasChanged: true,
        }
    },
    [type.SAVE_REFINEMENT_REASON_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SAVE_REFINEMENT_REASON_SUCCESS]: (state, action) => {
        const { refinementReason } = action.payload
        return {
            ...state,
            refinementReason,
            fetching: false,
            hasChanged: false,
        }
    },
    [type.SAVE_REFINEMENT_REASON_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/refinement/state/reducer.js